/* globals jQuery */

jQuery( document ).ready(function($){

	$('form[name="options"] label').each(function(){
		$(this).html( $(this).attr('for') );
	});

	$('.proinput input[type="submit"]').attr('value', 'zoeken');

	$('.asp_main_container').each(function(){
		var id = $(this).attr('data-id');

		$(this).find('.proinput .orig').attr('id','orig'+id);
		$('<label for="orig'+id+'">Zoek</label>').insertAfter( $(this).find('.orig') );

		$(this).find('.proinput .autocomplete').attr('id','autocomplete'+id);
		$('<label for="autocomplete'+id+'">Zoek</label>').insertAfter( $(this).find('.autocomplete') );
	});

	$(document).on('click', '.close-button', function(){
		$('.menu-icon').focus();
	});

	$('.off-canvas #menu-main .menu-item:last-child').keydown(function() {
		$('#logo').focus();
		$('.off-canvas .close-button').click();
	});

	$('.off-canvas .close-button').on('keydown blur', function(e) {
		if (e.shiftKey && e.keyCode === 9) { // Shift+tab
			$('.skip-link:last-child').focus();
			$('.off-canvas .close-button').click();
		}
	});

});
